<div class="tw-flex tw-items-center tw-justify-center" *ngIf="loading">
  <i class="bwi bwi-spinner bwi-spin bwi-3x" aria-hidden="true"></i>
</div>

<auth-input-password
  *ngIf="!loading"
  [email]="email"
  [inputPasswordFlow]="InputPasswordFlow.SetInitialPassword"
  [masterPasswordPolicyOptions]="masterPasswordPolicyOptions"
  [loading]="submitting"
  [primaryButtonText]="{ key: 'createAccount' }"
  (onPasswordFormSubmit)="handlePasswordFormSubmit($event)"
></auth-input-password>
